<div class="console-page">
  <div class="console-content">
    <app-page-header
      title="PayLink"
      description="Crear orden con PayLink embebido."
    ></app-page-header>

    <form [formGroup]="myForm">
      <app-console-section title="Configuración API">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="paylink-environment">Ambiente</label>
            <select id="paylink-environment" class="console-select" formControlName="environment">
              <option value="QA">QA — qas.api.epago.pe</option>
              <option value="DEV">DEV — dev.api.epago.pe</option>
            </select>
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-merchantKey">API Key (Identifier)</label>
            <input
              id="paylink-merchantKey"
              class="console-input"
              formControlName="merchantKey"
              placeholder="Ingrese su API Key"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-secretKey">Clave secreta (token)</label>
            <input
              id="paylink-secretKey"
              class="console-input"
              formControlName="secretKey"
              placeholder="Ingrese su clave secreta"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-orderId">ID de orden</label>
            <input
              id="paylink-orderId"
              class="console-input mono"
              formControlName="orderId"
              placeholder="ID de la orden"
              readonly
            />
            <span class="console-field__hint">Se actualiza automáticamente cada segundo</span>
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-currency">Moneda</label>
            <select id="paylink-currency" class="console-select" formControlName="currency">
              <option value="PEN">PEN</option>
              <option value="USD">USD</option>
            </select>
          </div>

          <div class="console-field console-form-grid__full">
            <label class="console-field__label" for="paylink-paymentMethod">Método de pago</label>
            <select id="paylink-paymentMethod" class="console-select" formControlName="paymentMethod">
              <option value="Tarjetas-Credito-Debito-PROM">Tarjetas-Credito-Debito-PROM</option>
              <option value="AGORAWEB">AGORAWEB</option>
              <option value="Tarjetas-INTERBANK">Tarjetas-INTERBANK</option>
              <option value="Tarjeta-Oh-Cuotas">Tarjeta-Oh-Cuotas | Tarjeta de Crédito Sip</option>
            </select>
          </div>

          <div class="console-field console-form-grid__full">
            <label class="console-checkbox">
              <input type="checkbox" formControlName="qrPayment" />
              Habilitar pago con QR
            </label>
          </div>

          <div class="console-field console-form-grid__full">
            <label class="console-checkbox">
              <input type="checkbox" formControlName="cardRegistered" />
              Flujo card-register pay-link (cardRegistered=true → VALIDATE React SDK)
            </label>
          </div>

          <div class="console-field console-form-grid__full">
            <label class="console-checkbox">
              <input type="checkbox" formControlName="integrationMode" />
              Habilitar pago con integración mode 1
            </label>
          </div>

          <div class="console-field console-form-grid__full">
            <label class="console-checkbox">
              <input type="checkbox" formControlName="createdFromVtex" />
              Simular orden desde VTEX
            </label>
          </div>

          <div class="console-field console-form-grid__full">
            <p class="console-field__hint">
              El <strong>signedElement</strong> se genera automáticamente con la fórmula: orderNumber + currencyCode + amount
            </p>
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Cliente">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="paylink-identifier">Identificador del cliente</label>
            <input
              id="paylink-identifier"
              class="console-input"
              formControlName="identifier"
              placeholder="Identificador único del cliente"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-email">Email</label>
            <input
              id="paylink-email"
              class="console-input"
              formControlName="email"
              type="email"
              placeholder="Email del cliente"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-name">Nombre</label>
            <input
              id="paylink-name"
              class="console-input"
              formControlName="name"
              placeholder="Nombre del cliente"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-lastname">Apellido</label>
            <input
              id="paylink-lastname"
              class="console-input"
              formControlName="lastname"
              placeholder="Apellido del cliente"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-phone">Teléfono</label>
            <input
              id="paylink-phone"
              class="console-input"
              formControlName="phone"
              placeholder="Teléfono del cliente"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-documentType">Tipo de documento</label>
            <select id="paylink-documentType" class="console-select" formControlName="documentType">
              <option value="DNI">DNI</option>
              <option value="CE">CE</option>
              <option value="RUC">RUC</option>
              <option value="PAS">Pasaporte</option>
            </select>
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-documentNumber">Número de documento</label>
            <input
              id="paylink-documentNumber"
              class="console-input"
              formControlName="documentNumber"
              placeholder="Número de documento"
            />
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Dirección">
        <div class="console-form-grid">
          <div class="console-field console-form-grid__full">
            <label class="console-field__label" for="paylink-address1">Dirección</label>
            <input
              id="paylink-address1"
              class="console-input"
              formControlName="address1"
              placeholder="Dirección completa"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-addressCountry">País</label>
            <input
              id="paylink-addressCountry"
              class="console-input"
              formControlName="addressCountry"
              placeholder="País"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-addressLevel1">Departamento</label>
            <input
              id="paylink-addressLevel1"
              class="console-input"
              formControlName="addressLevel1"
              placeholder="Departamento"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-addressLevel2">Provincia</label>
            <input
              id="paylink-addressLevel2"
              class="console-input"
              formControlName="addressLevel2"
              placeholder="Provincia"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-addressLevel3">Distrito</label>
            <input
              id="paylink-addressLevel3"
              class="console-input"
              formControlName="addressLevel3"
              placeholder="Distrito"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-addressZip">Código postal</label>
            <input
              id="paylink-addressZip"
              class="console-input"
              formControlName="addressZip"
              placeholder="Código postal"
            />
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Pago">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="paylink-discounts">Descuento</label>
            <input
              id="paylink-discounts"
              class="console-input"
              formControlName="discounts"
              type="number"
              placeholder="Descuento"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-shipping">Envío</label>
            <input
              id="paylink-shipping"
              class="console-input"
              formControlName="shipping"
              type="number"
              placeholder="Costo de envío"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-taxes">Impuestos</label>
            <input
              id="paylink-taxes"
              class="console-input"
              formControlName="taxes"
              type="number"
              placeholder="Impuestos"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-fee">Tarifa</label>
            <input
              id="paylink-fee"
              class="console-input"
              formControlName="fee"
              type="number"
              placeholder="Tarifa"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="paylink-expirationDate">Fecha de expiración</label>
            <input
              id="paylink-expirationDate"
              class="console-input"
              formControlName="expirationDate"
              placeholder="Fecha de expiración"
            />
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Carrito">
        <div class="minicart-container" [formGroup]="minicartItems">
          <div class="console-form-grid">
            <div class="console-field">
              <label class="console-field__label" for="paylink-minicart-sku">SKU</label>
              <input
                id="paylink-minicart-sku"
                class="console-input"
                formControlName="sku"
                placeholder="SKU del producto"
              />
            </div>

            <div class="console-field">
              <label class="console-field__label" for="paylink-minicart-name">Nombre</label>
              <input
                id="paylink-minicart-name"
                class="console-input"
                formControlName="name"
                placeholder="Nombre del producto"
              />
            </div>

            <div class="console-field">
              <label class="console-field__label" for="paylink-minicart-category">Categoría</label>
              <input
                id="paylink-minicart-category"
                class="console-input"
                formControlName="category"
                placeholder="Categoría"
              />
            </div>

            <div class="console-field">
              <label class="console-field__label" for="paylink-minicart-amount">Precio</label>
              <input
                id="paylink-minicart-amount"
                class="console-input"
                formControlName="amount"
                type="number"
                placeholder="Precio unitario"
              />
            </div>

            <div class="console-field">
              <label class="console-field__label" for="paylink-minicart-quantity">Cantidad</label>
              <input
                id="paylink-minicart-quantity"
                class="console-input"
                formControlName="quantity"
                type="number"
                placeholder="Cantidad"
              />
            </div>

            <div class="console-field">
              <label class="console-field__label" for="paylink-minicart-discount">Descuento ítem</label>
              <input
                id="paylink-minicart-discount"
                class="console-input"
                formControlName="discount"
                type="number"
                placeholder="Descuento"
              />
            </div>

            <div class="console-field">
              <label class="console-field__label" for="paylink-minicart-shipping">Envío ítem</label>
              <input
                id="paylink-minicart-shipping"
                class="console-input"
                formControlName="shipping"
                type="number"
                placeholder="Envío del item"
              />
            </div>
          </div>

          <div class="add-item-button">
            <button class="console-btn" type="button" (click)="addMinicartItem()">Agregar ítem</button>
          </div>

          <div class="cart-items-container" *ngIf="items.length; else emptyPaylinkCart">
            <div class="demo-minicart-row demo-minicart-row--head">
              <span>SKU</span>
              <span>Producto</span>
              <span>P/U</span>
              <span>Total</span>
              <span>Cant.</span>
              <span>Categ.</span>
              <span>Desc.</span>
              <span>Envío</span>
              <span></span>
            </div>
            <div *ngFor="let item of items; let i = index" class="demo-minicart-row">
              <span class="demo-minicart-row__mono">{{ item.sku }}</span>
              <span>{{ item.name }}</span>
              <span>{{ item.unitAmount }}</span>
              <span>{{ item.amount }}</span>
              <span>{{ item.quantity }}</span>
              <span>{{ item.category }}</span>
              <span>{{ item.discount * -1 }}</span>
              <span>{{ item.shipping }}</span>
              <button
                class="console-btn"
                type="button"
                (click)="removeMinicartItem(i)"
                aria-label="Quitar ítem"
              >
                Quitar
              </button>
            </div>
          </div>
          <ng-template #emptyPaylinkCart>
            <p class="demo-minicart-empty">No hay ítems en el carrito. Agregá uno para probar el minicart.</p>
          </ng-template>
        </div>
      </app-console-section>

      <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
    </form>
  </div>

  <div class="console-action-bar">
    <span class="console-action-bar__total">
      Total
      <span class="console-action-bar__amount">
        {{ myForm.get('currency')?.value }} {{ calculateTotal() | number:'1.2-2' }}
      </span>
    </span>
    <button
      class="console-btn console-btn--primary"
      type="button"
      (click)="createPaylink()"
      [disabled]="isLoading"
    >
      <span *ngIf="!isLoading">Crear PayLink</span>
      <span *ngIf="isLoading">Creando...</span>
    </button>
  </div>

  <div *ngIf="showIframe" class="iframe-overlay" (click)="closeIframe()">
    <button
      type="button"
      class="close-button"
      (click)="handleCloseButtonClick($event)"
      aria-label="Cerrar"
    >
      ×
    </button>
    <div class="iframe-container" (click)="$event.stopPropagation()">
      <p *ngIf="!paylinkUrl" class="paylink-overlay-loading">Cargando PayLink…</p>
      <iframe
        *ngIf="paylinkUrl"
        #paylinkIframe
        [src]="paylinkUrl | safe:'resourceUrl'"
        class="paylink-iframe"
        frameborder="0"
        allowfullscreen
        (load)="onIframeLoad()"
      ></iframe>
    </div>
  </div>
</div>
